"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateIsBeforeOrEqualToPresent = exports.dateIsBeforeMaximumDate = exports.dateIsAfterMinimumDate = exports.dateInYearsRangeStringSchemaFactory = exports.isDateStringInAgeRangeFactory = exports.isAgeInRangeFactory = exports._isAgeInRangeFp = exports._getYearsToNowFP = exports.ONE_YEAR_IN_MS = void 0;
const zod_1 = require("zod");
const constants_1 = require("./constants");
exports.ONE_YEAR_IN_MS = 31536000000;
function _getYearsToNowFP(dateString, dateNow, dateParse) {
    const dateMs = dateParse(dateString);
    const nowMs = dateNow();
    return (nowMs - dateMs) / exports.ONE_YEAR_IN_MS;
}
exports._getYearsToNowFP = _getYearsToNowFP;
function _isAgeInRangeFp(age, minAge, maxAge) {
    return age >= minAge && age <= maxAge;
}
exports._isAgeInRangeFp = _isAgeInRangeFp;
;
function isAgeInRangeFactory(minAge, maxAge) {
    return function isAgeInRange(age) {
        return _isAgeInRangeFp(age, minAge, maxAge);
    };
}
exports.isAgeInRangeFactory = isAgeInRangeFactory;
function isDateStringInAgeRangeFactory(minAge, maxAge) {
    return function isDateStringInAgeRange(dateString) {
        const age = _getYearsToNowFP(dateString, Date.now, Date.parse);
        return _isAgeInRangeFp(age, minAge, maxAge);
    };
}
exports.isDateStringInAgeRangeFactory = isDateStringInAgeRangeFactory;
// if you add a return type to this function, be sure to check that TS doesn't change the type definitions that get built to `any` for the properties that use this function
function dateInYearsRangeStringSchemaFactory(minAge, maxAge, errorMessage = `Date should be beetween ${minAge} and ${maxAge} years from today's date`) {
    return zod_1.z
        .string()
        .regex(constants_1.REGEX.iso8601Date, {
        message: 'Date should be a valid ISO 8601 date string',
    })
        .refine(isDateStringInAgeRangeFactory(minAge, maxAge), { message: errorMessage });
}
exports.dateInYearsRangeStringSchemaFactory = dateInYearsRangeStringSchemaFactory;
const dateIsAfterMinimumDate = (dateToCompare, minimumIsoDate) => new Date(dateToCompare) > new Date(minimumIsoDate);
exports.dateIsAfterMinimumDate = dateIsAfterMinimumDate;
const dateIsBeforeMaximumDate = (dateToCompare, maximumIsoDate) => new Date(dateToCompare) < new Date(maximumIsoDate);
exports.dateIsBeforeMaximumDate = dateIsBeforeMaximumDate;
const dateIsBeforeOrEqualToPresent = (dateToCompare) => new Date(dateToCompare) <= new Date(Date.now());
exports.dateIsBeforeOrEqualToPresent = dateIsBeforeOrEqualToPresent;
